import { ManagedByIwocaPill } from 'components/ManagedByIwocaPill/ManagedByIwocaPill';
import { useLocale } from 'hooks/useLocale';
import styles from './CreatedCell.module.css';

type TProps = {
  date: string;
  isPartnerChannel: boolean;
};

export const CreatedCell = ({ date, isPartnerChannel }: TProps) => {
  const { i18n } = useLocale();

  const createdDate = i18n.date(date, {
    day: '2-digit',
    month: 'short',
    year: '2-digit',
  });

  return (
    <>
      <div>{createdDate}</div>
      {isPartnerChannel && (
        <div className={styles.managedByIwocaPill}>
          <ManagedByIwocaPill size="small" />
        </div>
      )}
    </>
  );
};
